module.exports = __webpack_public_path__ + "img/logo.d1bb7a6f.png";